import styles from "./index.css";
import PropTypes from "prop-types";
import { DELIMITER } from "../ariaConstants";

import useFixedWhiteOverlayBugOniOS from "./useFixedWhiteOverlayBugOniOS";

const ProductTilesWrapper = ({ children }) => {
  useFixedWhiteOverlayBugOniOS();

  return (
    <>
      <section className={styles.productTilesWrapper}>{children}</section>
      <span className={styles.ariaDelimiter} id={DELIMITER}>
        ;
      </span>
    </>
  );
};

ProductTilesWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

export default ProductTilesWrapper;
